<template>
  <Teleport to="body">
    <div class="toast-container">
      <!-- Top Right -->
      <div class="position-fixed top-1 end-1 z-index-3 toast-stack">
        <TransitionGroup name="toast">
          <toast-notification
            v-for="toast in topRightToasts"
            :id="toast.id"
            :key="toast.id"
            :title="toast.title"
            :message="toast.message"
            :type="toast.type"
            :timeout="toast.timeout"
            :position="toast.position"
            @close="removeToast"
          />
        </TransitionGroup>
      </div>

      <!-- Top Left -->
      <div class="position-fixed top-1 start-1 z-index-3 toast-stack">
        <TransitionGroup name="toast">
          <toast-notification
            v-for="toast in topLeftToasts"
            :id="toast.id"
            :key="toast.id"
            :title="toast.title"
            :message="toast.message"
            :type="toast.type"
            :timeout="toast.timeout"
            :position="toast.position"
            @close="removeToast"
          />
        </TransitionGroup>
      </div>

      <!-- Top Center -->
      <div class="position-fixed top-1 start-50 translate-middle-x z-index-3 toast-stack">
        <TransitionGroup name="toast">
          <toast-notification
            v-for="toast in topCenterToasts"
            :id="toast.id"
            :key="toast.id"
            :title="toast.title"
            :message="toast.message"
            :type="toast.type"
            :timeout="toast.timeout"
            :position="toast.position"
            @close="removeToast"
          />
        </TransitionGroup>
      </div>

      <!-- Bottom Right -->
      <div class="position-fixed bottom-1 end-1 z-index-3 toast-stack">
        <TransitionGroup name="toast">
          <toast-notification
            v-for="toast in bottomRightToasts"
            :id="toast.id"
            :key="toast.id"
            :title="toast.title"
            :message="toast.message"
            :type="toast.type"
            :timeout="toast.timeout"
            :position="toast.position"
            @close="removeToast"
          />
        </TransitionGroup>
      </div>

      <!-- Bottom Left -->
      <div class="position-fixed bottom-1 start-1 z-index-3 toast-stack">
        <TransitionGroup name="toast">
          <toast-notification
            v-for="toast in bottomLeftToasts"
            :id="toast.id"
            :key="toast.id"
            :title="toast.title"
            :message="toast.message"
            :type="toast.type"
            :timeout="toast.timeout"
            :position="toast.position"
            @close="removeToast"
          />
        </TransitionGroup>
      </div>

      <!-- Bottom Center -->
      <div class="position-fixed bottom-1 start-50 translate-middle-x z-index-3 toast-stack">
        <TransitionGroup name="toast">
          <toast-notification
            v-for="toast in bottomCenterToasts"
            :id="toast.id"
            :key="toast.id"
            :title="toast.title"
            :message="toast.message"
            :type="toast.type"
            :timeout="toast.timeout"
            :position="toast.position"
            @close="removeToast"
          />
        </TransitionGroup>
      </div>
    </div>
  </Teleport>
</template>

<script>
import ToastNotification from "./ToastNotification.vue";
import { toastEventBus } from "@/plugins/toast";

export default {
  name: "ToastContainer",
  components: {
    ToastNotification
  },
  data() {
    return {
      toasts: []
    };
  },
  computed: {
    topRightToasts() {
      return this.toasts.filter(t => t.position === "top-right");
    },
    topLeftToasts() {
      return this.toasts.filter(t => t.position === "top-left");
    },
    topCenterToasts() {
      return this.toasts.filter(t => t.position === "top-center");
    },
    bottomRightToasts() {
      return this.toasts.filter(t => t.position === "bottom-right");
    },
    bottomLeftToasts() {
      return this.toasts.filter(t => t.position === "bottom-left");
    },
    bottomCenterToasts() {
      return this.toasts.filter(t => t.position === "bottom-center");
    }
  },
  mounted() {
    toastEventBus.on("add", this.addToast);
    toastEventBus.on("remove", this.removeToast);
    toastEventBus.on("clear", this.clearAllToasts);
  },
  beforeUnmount() {
    toastEventBus.off("add", this.addToast);
    toastEventBus.off("remove", this.removeToast);
    toastEventBus.off("clear", this.clearAllToasts);
  },
  methods: {
    addToast(toast) {
      this.toasts.push(toast);
    },
    removeToast(id) {
      const index = this.toasts.findIndex(t => t.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    },
    clearAllToasts() {
      this.toasts = [];
    }
  }
};
</script>

<style scoped>
.toast-stack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Clear the status bar / home indicator in the iOS app (env() is 0 on the website). */
.toast-stack.top-1 {
  margin-top: env(safe-area-inset-top);
}

.toast-stack.bottom-1 {
  margin-bottom: env(safe-area-inset-bottom);
}

.z-index-3 {
  z-index: 9999 !important;
}

/* Toast transition animations */
.toast-enter-active {
  animation: toast-in 0.3s ease-out;
}

.toast-leave-active {
  animation: toast-out 0.3s ease-in;
}

@keyframes toast-in {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes toast-out {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(100%);
  }
}
</style>
